import { collectScopes } from '../bom/bom_service.js?v=20260904c';
import { collectBomUsageSnapshot } from '../statistics/bom_usage_snapshot_service.js?v=20260901b';

// Query the public BOM hooks for the current project, including unsaved edits.
// No registration/write side effect: saving an order already persists system_code
// and article_number through the statistics snapshot service.
export async function collectCurrentSystemArticleUsages() {
  const bom = await import('../bom/bom.js?v=20260903c');
  const scopes = collectScopes();
  if (!scopes.length) return [];
  const roots = bom.createBomRowsForScopeIds(scopes.map(scope => scope.id));
  const resolved = await collectBomUsageSnapshot({ scopes });
  const usages = [...roots.map(row => ({ systemId: row.sourceSystemId, articleNumber: row.articleNo || row.ART_NRA || row.number || row.articleNumber })),
    ...resolved.filter(row => !row.isManual).map(row => ({ systemId: row.sourceSystemCode, articleNumber: row.articleNo }))];
  const distinct = new Map();
  for (const usage of usages) {
    if (typeof usage.systemId !== 'string' || typeof usage.articleNumber !== 'string' || !usage.systemId || !usage.articleNumber) continue;
    distinct.set(JSON.stringify([usage.systemId, usage.articleNumber.toLowerCase()]), usage);
  }
  return [...distinct.values()];
}
